namespace Client.InfrastructureTypes

open Fable.React.Props

[<RequireQualifiedAccess>]
module Html =
    let bold = Class "has-text-weight-bold"

    let label = Class "mysens-label"